<template>
  <main class="blog-catalog">
    <div class="blog-catalog-top">
      <DefBreadCrumbs v-if="getActiveMenuName" :result="getBreadCrumbs" />
      <DefTitle v-if="screenWidth < 768 || !getActiveMenuName" :result="3">
        <h1>{{ getActiveMenuName || messages.title }}</h1>
      </DefTitle>
    </div>
    <div class="blog-catalog-items">
      <BlogCatalogCard v-for="(item, key) in items" :result="item" />
    </div>
    <CatalogPagination
      v-if="getActiveMenuName"
      :result="pagination"
      @changePage="changePageData"
      @addMore="getMoreItems"
    />
  </main>
</template>

<script lang="ts" setup>
import useScreenWidth from '@use/useScreenWidth';
import DefBreadCrumbs from '@components/Def/DefBreadCrumbs/DefBreadCrumbs.vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import BlogCatalogCard from '@components/Blog/BlogCatalog/BlogCatalogCard.vue';
import CatalogPagination from '@components/Catalog/CatalogPagination/CatalogPagination.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { useCatalogStore } from '@/storePinia/stores/catalog';
import { computed } from 'vue';

const resultsStore = useResultsStore();
const catalogStore = useCatalogStore();
const screenWidth = useScreenWidth();

const messages = computed(() => resultsStore?.messages?.blog);
const blogMenu = computed(() => resultsStore?.blogMenu);
const getBreadCrumbs = computed(() => resultsStore?.breadcrumbs?.slice(1));
const getActiveMenuName = computed(() => blogMenu.value?.find((el) => el.active)?.name);
const items = computed(() => catalogStore.catalogSectionList?.items);
const pagination = computed(() => catalogStore.catalogSectionList?.pagination);

const changePageData = (page) => {
  catalogStore.changePageData(page);
};

const getMoreItems = (path) => {
  catalogStore.getMoreItems(path);
};
</script>

<style lang="scss" scoped>
.blog-catalog {
  :deep(.catalog-pagination) {
    margin-bottom: 64px;
    @include point-md {
      margin-bottom: 80px;
    }
  }
}
.blog-catalog-items {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 24px;
  margin-bottom: 64px;
  @include point-md {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: 20px;
  }
  @include point-lg {
    grid-gap: 40px;
    margin-bottom: 80px;
  }
  :deep(> *) {
    background-color: green;
    &:first-child {
      @include point-md {
        grid-row-start: 1;
        grid-row-end: 3;
      }
    }
    &:nth-child(4) {
      @include point-md {
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }
    &:nth-child(6) {
      @include point-md {
        grid-column-start: 2;
        grid-column-end: 3;
        grid-row-start: 4;
        grid-row-end: 6;
      }
    }
    &:nth-child(8) {
      @include point-md {
        grid-row-start: 6;
        grid-row-end: 8;
      }
    }
  }
}
.blog-catalog-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  @include point-md {
    padding: 16px 0;
  }
  :deep(.def-title) {
    margin-bottom: 0;
  }
  :deep(.def-bread-crumbs) {
    padding: 0;
  }
}
</style>
